import React from "react";

function TextIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      viewBox="0 0 48 48"
    >
      <g id="Group_30680" data-name="Group 30680" transform="translate(-0.235)">
        <circle
          id="Ellipse_327"
          data-name="Ellipse 327"
          cx="24"
          cy="24"
          r="24"
          transform="translate(0.235)"
          opacity="0.7"
        />
        <g
          id="Group_26695"
          data-name="Group 26695"
          transform="translate(12.235 13.683)"
        >
          <rect
            id="Rectangle_12942"
            data-name="Rectangle 12942"
            width="24"
            height="24"
            transform="translate(0 0.317)"
            fill="red"
            opacity="0"
          />
          <path
            id="Path_16226"
            data-name="Path 16226"
            d="M17.443,7.111V26.526H14.332V7.111H5V4H26.775V7.111Z"
            transform="translate(-4.154 -4)"
            fill="#fff"
          />
        </g>
      </g>
    </svg>
  );
}

export default TextIcon;
